import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BackButton from "../components/Buttons/BackButton";
import {
  Body,
  Container,
  Modal,
  ModalContent,
  Wrapper,
} from "../style/view.styles";
import ApplicationForm from "../components/Elements/ApplicationForm";
import ConfirmWithdrawModal from "../components/Elements/ConfirmCancelModal";
import EmptyState from "../components/Elements/EmptyState";
import { Sidebar, SidebarContainer } from "../style/sidebar.styles";
import { getLoggedInUser } from "../utils/AuthHandler";
import OpportunityDetailsBody from "../components/Elements/OpportunityDetailsBody";
import { deleteEntityInstance } from "../utils/RequestHandler";

export default function OpportunityDetails() {
  const location = useLocation();
  const opportunity = location.state?.opportunity || null;
  const [isApplyModalOpen, setIsApplyModalOpen] = useState(false);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const handleApplyModalClose = () => setIsApplyModalOpen(false);
  const handleCancelModalClose = () => setIsCancelModalOpen(false);
  const [formStatus, setFormStatus] = useState({ message: "", type: "" });
  const [submitting, setSubmitting] = useState(false);
  const [isApplicationSubmitted, setIsApplicationSubmitted] = useState(false);
  const navigate = useNavigate();

  const handleModalBackgroundClick = (e) => {
    if (e.target === e.currentTarget) {
      handleApplyModalClose();
    }
  };
  const [user, setUser] = useState(null);

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const user = getLoggedInUser();
    setIsLoggedIn(!!user);
    setUser(user);
  }, []);

  const handleCloseOpportunity = async (to_close) => {
    try {
      setSubmitting(true);

      const response = await deleteEntityInstance(
        "opportunities",
        to_close.uuid
      );
      if (response.success) {
        navigate("/opportunities");
      } else {
        setFormStatus({
          message: response.result ?? "An error occurred. Please try again.",
          type: "error",
        });
      }
    } catch (error) {
      setFormStatus({
        message: "An error occurred while adding your opportunity.",
        type: "error",
      });
    } finally {
      setSubmitting(false);
    }
  };

  if (!opportunity) {
    return (
      <>
        <Wrapper className="paleBlueGreyBg">
          <Container>
            <Body>
              <EmptyState message={"Opportunity details not provided."} />
            </Body>
          </Container>
        </Wrapper>
      </>
    );
  }

  return (
    <>
      <Wrapper className="paleBlueGreyBg">
        <Container>
          <SidebarContainer>
            <Sidebar isExpanded={true}>
              <BackButton path="/opportunities" />
            </Sidebar>
          </SidebarContainer>

          <OpportunityDetailsBody
            opportunity={opportunity}
            isLoggedIn={isLoggedIn}
            user={user}
            setIsApplyModalOpen={setIsApplyModalOpen}
            setIsCancelModalOpen={setIsCancelModalOpen}
            isApplyModalOpen={isApplyModalOpen}
            isCancelModalOpen={isCancelModalOpen}
            isApplicationSubmitted={isApplicationSubmitted}
          />
        </Container>
      </Wrapper>
      {isApplyModalOpen && (
        <Modal onClick={handleModalBackgroundClick}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            <ApplicationForm
              selectedOpportunity={opportunity}
              handleModalClose={handleApplyModalClose}
              setIsApplicationSubmitted={setIsApplicationSubmitted}
            />
          </ModalContent>
        </Modal>
      )}
      {isCancelModalOpen && (
        <ConfirmWithdrawModal
          selectedOpportunity={opportunity}
          handleModalClose={handleCancelModalClose}
          handleWithdraw={handleCloseOpportunity}
          formStatus={formStatus}
          submitting={submitting}
        />
      )}
    </>
  );
}
